import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
const navItems = [{
  to: '/',
  label: 'Inicio'
}, {
  to: '/metodo',
  label: 'El Método'
}, {
  to: '/sesiones',
  label: 'Sesiones'
}, {
  to: '/sobre-laura',
  label: 'Sobre Laura'
}, {
  to: '/preguntas',
  label: 'Preguntas'
}];
export function NavBar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 bg-white border-b border-teal/15 ${scrolled || open ? 'shadow-md' : 'shadow-sm'}`} data-id="element-279">
        {/* Top row: Logo centered */}
        <div className="relative max-w-7xl mx-auto px-6 pt-4 pb-3 flex items-center justify-center" data-id="element-280">
          <Link to="/" aria-label="Inicio" className="flex flex-col items-center gap-1" data-id="element-281">
            <Logo color="#00A99D" size={84} showText={false} data-id="element-282" />
            <span className="font-serif text-teal-dark uppercase tracking-[0.32em] text-[11px] md:text-xs leading-tight mt-1" data-id="element-283">
              Las Llaves de Tu Alma
            </span>
          </Link>

          {/* Mobile hamburger absolute right */}
          <button className="absolute right-4 top-1/2 -translate-y-1/2 md:hidden text-teal-dark p-2" onClick={() => setOpen(!open)} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} data-id="element-284">
            {open ? <X size={28} data-id="element-285" /> : <Menu size={28} data-id="element-286" />}
          </button>
        </div>

        {/* Bottom row: Menu (desktop only) */}
        <div className="hidden md:flex relative max-w-7xl mx-auto px-6 pb-3 items-center justify-center" data-id="element-287">
          <ul className="flex items-center gap-2 lg:gap-3" data-id="element-288">
            {navItems.map(item => <li key={item.to} data-id="element-289">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `font-serif px-5 py-2 rounded-full text-base lg:text-lg tracking-wide transition-all ${isActive ? 'bg-teal text-white' : 'text-teal-dark hover:bg-cream hover:text-teal'}`} data-id="element-290">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>

          <a href="https://wa.me/542616167908?text=Hola%20Laura!%20Quiero%20agendar%20una%20sesi%C3%B3n." target="_blank" rel="noopener noreferrer" className="hidden lg:inline-block absolute right-6 bg-teal text-white text-sm font-medium px-6 py-2.5 rounded-full hover:bg-teal-dark transition-colors tracking-widest" data-id="element-291">
            AGENDAR
          </a>
        </div>
      </header>

      {/* Mobile drawer */}
      <AnimatePresence data-id="element-292">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-30 bg-cream md:hidden pt-32" data-id="element-293">
            <motion.ul initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 20,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center justify-center gap-7 px-6 py-8" data-id="element-294">
              {navItems.map(item => <li key={item.to} data-id="element-295">
                  <NavLink to={item.to} end={item.to === '/'} onClick={() => setOpen(false)} className={({
              isActive
            }) => `font-serif text-3xl ${isActive ? 'text-teal italic' : 'text-teal-dark'}`} data-id="element-296">
                    {item.label}
                  </NavLink>
                </li>)}
              <li className="pt-6" data-id="element-297">
                <a href="https://wa.me/542616167908?text=Hola%20Laura!%20Quiero%20agendar%20una%20sesi%C3%B3n." target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="inline-block bg-teal text-white text-base font-medium px-10 py-4 rounded-full tracking-widest" data-id="element-298">
                  AGENDAR SESIÓN
                </a>
              </li>
            </motion.ul>
          </motion.div>}
      </AnimatePresence>

      {/* Spacer to offset fixed header */}
      <div className="h-[140px] md:h-[180px]" aria-hidden="true" data-id="element-299" />
    </>;
}